import React, { useState } from "react";
import { Box, Center, Spinner } from "@chakra-ui/react";

const AIAgentsPage = () => {
    const [loading, setLoading] = useState(true);

    return (
        <Box position="fixed" top="50" left="0" width="100vw" height="100vh" zIndex="0" overflow="hidden">
            {loading && (
                <Box pos="absolute" inset={0} bg="white" zIndex="10">
                    <Center h="100%">
                        <Spinner size="xl" color="teal.500" />
                    </Center>
                </Box>
            )}

            <iframe
                title="PlanTrainDoc Landing Page"
                src="https://www.plantraindoc.de"
                width="100%"
                height="100%"
                style={{ border: "none" }}
                onLoad={() => setLoading(false)}
            />
        </Box>
    );
};

export default AIAgentsPage;
